import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { getDetailAppInstanceQuery } from '../apis';
import { setFieldAppInstance } from '..';
import { deepClone } from '@tenant/utility/helper/Utils';
import { useDispatch } from 'react-redux';

// `options.enabled` (default true) lets callers skip the detail read until they have a
// real id — e.g. the pipelines wizard/list mount before an App Instance is selected
// (M1 fix). Backward-compatible: existing callers that don't pass `options` keep firing
// exactly as before whenever `id` is truthy.
const useGetDetailAppInstance = (id, { enabled = true } = {}) => {
  const dispatch = useDispatch();

  const getDetailAppInstance = useQuery({
    queryKey: ['app-instance-detail-' + id],
    queryFn: () => getDetailAppInstanceQuery(id),
    staleTime: 0,
    enabled: !!id && enabled,
    onSuccess: (data) => {
      dispatch(setFieldAppInstance({ field: 'list', value: deepClone(data) }));
    },
  });

  return getDetailAppInstance;
};

export default useGetDetailAppInstance;
